var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15778_132866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 14.7483L14.9073 12.5001L11.0039 10.252V14.7483Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7691 0.5H2.2309C1.2749 0.5 0.5 1.2749 0.5 2.2309V22.7691C0.5 23.7251 1.2749 24.5 2.2309 24.5H22.7691C23.7251 24.5 24.5 23.7251 24.5 22.7691V2.2309C24.5 1.2749 23.7251 0.5 22.7691 0.5V0.5ZM19.9982 12.5123C19.9982 12.5123 19.9982 14.9459 19.6895 16.1194C19.5164 16.7618 19.0099 17.2682 18.3676 17.4411C17.1941 17.75 12.5 17.75 12.5 17.75C12.5 17.75 7.81818 17.75 6.63239 17.4288C5.99005 17.256 5.48358 16.7493 5.31055 16.107C5.00165 14.9459 5.00165 12.5 5.00165 12.5C5.00165 12.5 5.00165 10.0665 5.31055 8.89301C5.4834 8.25067 6.00232 7.73175 6.63239 7.5589C7.80591 7.25 12.5 7.25 12.5 7.25C12.5 7.25 17.1941 7.25 18.3676 7.57117C19.0099 7.74402 19.5164 8.25067 19.6895 8.89301C20.0106 10.0665 19.9982 12.5123 19.9982 12.5123Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15778_132866"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.97a814bf8b78c85a2b84141ef133c862.svg";
export { ForwardRef as ReactComponent };